import loadable from '@loadable/component';

import { LoadingPageLoadable } from 'modules/main/pages/Loading';

export const InvoicesLinksLoadable = loadable(
  () =>
    import(
      /* webpackChunkName: "InvoicesLinks" */
      './InvoicesLinks.dynamic'
    ),
  { fallback: <LoadingPageLoadable /> },
);
